// src/components/compliance/TvrUploadCard.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx.
import FileDropzone from "../../shared/ui/FileDropzone";
import { MAX_FILE_SIZE } from "../../utils/compliance/constants";

export default function TvrUploadCard({ onSubmit }) {
  return (
    <FileDropzone
      theme="legacy"
      accept={[".docx", ".pdf"]}
      maxTotalSize={MAX_FILE_SIZE}
      title="Upload SOW document"
      description={
        <>
          Accepted formats: <strong>.docx</strong> or <strong>.pdf</strong>.
          The AI will analyse the SOW and identify value-add opportunities beyond the contracted scope.
        </>
      }
      submitLabel="Identify Value Opportunities"
      submittingLabel="Uploading…"
      onSubmit={onSubmit}
    />
  );
}
